export const projects = [
  {
    id: "cyber-patroller",
    title: "Cyber Patroller",
    subtitle: "Advanced Security Patrol Vehicle",
    category: "Under Development",
    status: "development" as const,
    description: "Next-generation electric patrol vehicle engineered for police and security forces in the Gulf region. Features dual 1000W motors, 120km range, and rugged IP66-rated construction designed for extreme desert conditions.",
    media: {
      type: "image" as const,
      src: "/projects/cyber-patroller.png",
      gallery: [
        "/projects/cyber-patroller.png",
        "/projects/cyber-patroller-2.png",
        "/projects/cyber-patroller-3.png",
        "/projects/cyber-patroller-4.png",
      ],
    },
    challenges: [
      "Adapting electronics to extreme Gulf temperatures exceeding 50°C",
      "Ensuring reliable performance across sand, gravel, and urban terrain",
      "Meeting security force requirements for extended patrol shifts",
      "Integrating advanced communication and PA systems",
    ],
    solutions: [
      "Dual 1000W motors with 20-inch high-performance tires (50km/h max)",
      "1740Wh large-capacity lithium battery with 120km range",
      "IP66-rated 200W PA system with 9 siren tones (125-135dB)",
      "Removable battery pack for quick swap and 5-6h charging",
    ],
    results: [
      { value: "2000W", label: "Total Power" },
      { value: "120km", label: "Max Range" },
      { value: "IP66", label: "Weather Rating" },
      { value: "2025", label: "Target Launch" },
    ],
  },
  {
    id: "health-holding-hajj",
    title: "Health Holding Co",
    subtitle: "Hajj 2026 Medical Transportation",
    category: "B2G • B2B • CTO",
    description: "Custom-engineered medical mobility vehicles for Health Holding Co, enabling rapid emergency response and patient transportation across Makkah and Al Masha'er during Hajj 2026. This flagship project combines B2G healthcare mandates, B2B fleet operations, and CTO innovation in a comprehensive 5-year partnership.",
    media: {
      type: "video" as const,
      src: "/projects/health-holding.mov",
    },
    challenges: [
      "Massive pilgrim gatherings requiring sub-minute medical response times",
      "Extreme summer heat conditions exceeding 45°C during peak Hajj days",
      "Navigating dense crowds and restricted holy site access zones",
      "Ensuring 24/7 fleet reliability across the entire pilgrimage season",
    ],
    solutions: [
      "Custom-engineered special model vehicles purpose-built for medical transport",
      "Deployed fleet of 60 specialized units with medical equipment integration",
      "Heat-resistant design with enhanced cooling for patient comfort",
      "Comprehensive 5-year service and maintenance partnership",
    ],
    results: [
      { value: "60", label: "Units Deployed" },
      { value: "5 Years", label: "Service Plan" },
      { value: "2M+", label: "SAR Contract" },
      { value: "Hajj 2026", label: "Launch Season" },
    ],
  },
  {
    id: "ministry-of-hajj-2026",
    title: "Ministry Of Hajj",
    subtitle: "Hajj 2026 Pilgrim Mobility Operations",
    category: "B2G",
    description: "Large-scale deployment of electric micro-mobility vehicles supporting the Ministry of Hajj's operational teams across Makkah and the holy sites during Hajj 2026, backed by full on-site technical support throughout the pilgrimage season.",
    challenges: [
      "Massive pilgrim density requiring rapid, agile mobility",
      "Extreme summer heat conditions exceeding 45°C",
      "24/7 operational reliability across the entire Hajj season",
      "Coordinating large fleet logistics across restricted holy zones",
    ],
    solutions: [
      "Deployed 290 specialized electric units across operational zones",
      "Dedicated on-site support team throughout the Hajj season",
      "Preventive maintenance and on-ground spare parts staging",
      "Operator training and rapid handover for ministry teams",
    ],
    results: [
      { value: "290", label: "Units Deployed" },
      { value: "On-Site", label: "Support" },
      { value: "B2G", label: "Contract" },
      { value: "Hajj 2026", label: "Season" },
    ],
  },
  {
    id: "dubai-ambulance",
    title: "Dubai Ambulance Services",
    subtitle: "Emergency Medical Response",
    category: "B2G",
    description: "Integration of iTank Dual electric vehicles to support emergency medical services across Dubai, enhancing response times and reducing operational costs.",
    media: {
      type: "video" as const,
      src: "/projects/dubai-ambulance.mp4",
    },
    challenges: [
      "High fuel costs for extensive fleet operations",
      "Need for quick, agile vehicles in congested areas",
      "Environmental compliance requirements",
      "24/7 operational reliability demands",
    ],
    solutions: [
      "Deployed 20+ iTank Dual units across key stations",
      "Custom medical equipment integration",
      "Comprehensive training for medical staff",
      "Dedicated maintenance and support team",
    ],
    results: [
      { value: "40%", label: "Faster Response" },
      { value: "60%", label: "Cost Reduction" },
      { value: "100%", label: "Zero Emissions" },
      { value: "24/7", label: "Uptime" },
    ],
  },
  {
    id: "jeddah-f1",
    title: "Jeddah Corniche Circuit",
    subtitle: "Formula 1 Track Operations",
    category: "B2B",
    description: "Official supplier of N13 MAX electric vehicles for track marshals and operations staff during Formula 1 Grand Prix events.",
    media: {
      type: "image" as const,
      src: "/projects/jeddah-f1.jpg",
    },
    challenges: [
      "Large venue requiring rapid mobility",
      "Strict noise regulations during events",
      "High visibility and premium appearance requirements",
      "Extreme heat conditions",
    ],
    solutions: [
      "Fleet of 30+ N13 MAX vehicles with custom livery",
      "Silent operation for broadcast requirements",
      "Enhanced cooling systems for desert climate",
      "Real-time GPS tracking for coordination",
    ],
    results: [
      { value: "30+", label: "Vehicles Deployed" },
      { value: "0 dB", label: "Noise Impact" },
      { value: "100%", label: "Event Coverage" },
      { value: "3", label: "Consecutive Years" },
    ],
  },
  {
    id: "exhibition-center",
    title: "Riyadh Exhibition Center",
    subtitle: "Venue Operations",
    category: "B2B",
    description: "Comprehensive mobility solution for one of the largest exhibition centers in the Middle East, serving visitors and staff alike.",
    challenges: [
      "Massive venue spanning multiple halls",
      "High visitor traffic during major events",
      "Indoor operation restrictions",
      "VIP transportation requirements",
    ],
    solutions: [
      "Mixed fleet of carts and personal mobility devices",
      "Dedicated VIP shuttle service",
      "Indoor-rated zero-emission vehicles",
      "On-site charging infrastructure",
    ],
    results: [
      { value: "50+", label: "Units Deployed" },
      { value: "10K+", label: "Daily Passengers" },
      { value: "95%", label: "Satisfaction Rate" },
      { value: "5", label: "Major Events" },
    ],
  },
];
